/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterInviteInfo } from "../../funcs/authClusterInviteInfo.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetClusterInviteInfoRequest$inboundSchema,
};

export const tool$authClusterInviteInfo: ToolDefinition<typeof args> = {
  name: "auth-cluster-invite-info",
  description: `Read cluster-invite info (public)`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterInviteInfo(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
